import {UserRole} from "../../../../authentication/authenticated-user";
import {ReleaseToggleState} from "../../../../../tools/release-toggles/release-toggle-state";
import {AssignType} from "../../../list-item";

export function canReassignTechnician(status: string, role: UserRole, technicianAssignType: AssignType | undefined): boolean {
  const featureReleased = ReleaseToggleState.getInstance().isReleased("REASSIGN_TECHNICIAN_547");
  const inPreanalysis = status === "PRE_ANALYSIS";
  const roleAllowed = role === "DATA_OFFICER";
  const assignedToTechnician = technicianAssignType === "DOCTOR";
  return featureReleased && inPreanalysis && roleAllowed && assignedToTechnician;
}
